// ABOUTME: Coordinates concurrent stage mutations for each applicant job.
// ABOUTME: Prevents an older mutation completion from replacing a newer stage.
export type ApplicantStageMutationState = {
    inFlightGeneration?: number;
    latestSuccessfulGeneration: number;
    nextGeneration: number;
};

export type ApplicantStageChange = ((successful?: boolean) => boolean) & {
    finish: () => void;
};

export const startApplicantStageChange = (
    generations: Map<string, ApplicantStageMutationState>,
    associationId: string
) => {
    const state = generations.get(associationId) || {
        latestSuccessfulGeneration: 0,
        nextGeneration: 0
    };
    if (state.inFlightGeneration) {
        return null;
    }
    const generation = state.nextGeneration + 1;
    let persistedSuccessfully = false;
    state.inFlightGeneration = generation;
    state.nextGeneration = generation;
    generations.set(associationId, state);

    const shouldApply = (successful = true) => {
        if (generations.get(associationId) !== state) {
            return false;
        }
        if (!successful && persistedSuccessfully) {
            return false;
        }
        if (!successful) {
            if (generation !== state.nextGeneration) {
                return false;
            }
            state.nextGeneration = generation - 1;
            return true;
        }
        if (generation < state.latestSuccessfulGeneration) {
            return false;
        }
        state.latestSuccessfulGeneration = generation;
        persistedSuccessfully = true;
        return true;
    };
    return Object.assign(shouldApply, {
        finish: () => {
            if (
                generations.get(associationId) === state &&
                state.inFlightGeneration === generation
            ) {
                delete state.inFlightGeneration;
            }
        }
    }) as ApplicantStageChange;
};
